import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="comment-form"
export default class extends Controller {
  static targets = ["saveButton", "textarea"]

  connect() {
    this.updateState()
  }

  updateState() {
    this.saveButtonTarget.disabled = this.textareaTarget.value.trim().length === 0
  }

  handleKeyboard(event) {
    if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
      event.preventDefault()
      if (this.textareaTarget.value.trim().length > 0) this.element.requestSubmit()
    }
  }

  submitStart() {
    this.saveButtonTarget.disabled = true
    this.saveButtonTarget.value = "Sending…"
  }

  submitEnd(event) {
    this.saveButtonTarget.value = "Comment"
    if (event.detail.success) {
      this.element.reset()
      this.textareaTarget.style.height = "auto"
    }
    this.updateState()
  }
}
